/* Adenzo mobile app layer — product gallery dots (phase 5).
   The product gallery is already a native scroll-snap strip on phones. This adds the app-style page dots
   under it (tap a dot to jump), driven by the strip's own scroll position, so swiping stays fully native.
   Layout changes (full-width slides, hidden thumbnails/arrows) live in assets/adenzo-app.css. */
(function () {
  'use strict';

  function init(viewer) {
    var list = viewer.querySelector('[id^="Slider-Gallery-"]');
    if (!list || viewer.querySelector('.adenzo-gallery-dots')) return;

    var wrapper = viewer.closest('.product__media-wrapper');
    if (wrapper) wrapper.classList.add('adenzo-gallery-ready');

    var dots = document.createElement('div');
    dots.className = 'adenzo-gallery-dots';
    dots.setAttribute('aria-hidden', 'true'); // the slide counter already tells assistive tech where you are
    list.parentNode.insertBefore(dots, list.nextSibling);

    var count = 0;
    var ticking = false;

    function slides() {
      return Array.prototype.filter.call(list.querySelectorAll('[id^="Slide-"]'), function (slide) {
        return slide.clientWidth > 0; // variant-hidden slides are display:none
      });
    }

    function render() {
      var items = slides();
      if (items.length !== count) {
        count = items.length;
        dots.innerHTML = '';
        for (var i = 0; i < count; i++) {
          var dot = document.createElement('span');
          dot.className = 'adenzo-gallery-dot';
          dot.setAttribute('data-index', String(i));
          dots.appendChild(dot);
        }
      }
      dots.hidden = count < 2;
      var active = 0;
      var best = Infinity;
      for (var j = 0; j < items.length; j++) {
        var distance = Math.abs(items[j].offsetLeft - list.scrollLeft);
        if (distance < best) { best = distance; active = j; }
      }
      var children = dots.children;
      for (var k = 0; k < children.length; k++) children[k].classList.toggle('is-active', k === active);
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; render(); });
    }

    dots.addEventListener('click', function (event) {
      var index = event.target.getAttribute && event.target.getAttribute('data-index');
      if (index === null || index === undefined) return;
      var target = slides()[parseInt(index, 10)];
      if (target) list.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    });

    list.addEventListener('scroll', schedule, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(list);
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    }
    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('slider-component[id^="GalleryViewer-"]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
